import React, { Component } from 'react';
import "./style.scss";

// imports components
import TopNavbar from "../Topnavbar";
import DetailsContent from "../DetailsContent";

class Details extends Component {
    render() {
        return (
            <div className="Details-container">
                <TopNavbar />
                <DetailsContent />
            </div>
        );
    }
}

export default Details;